import ApiClient from './ApiClient';

class AutomationFoldersAPI extends ApiClient {
  constructor() {
    super('automation_folders', { accountScoped: true });
  }
}

export default new AutomationFoldersAPI();
